import * as React from 'react'
import {Layout, LayoutProps} from 'react-admin'
import AppBar from './AppBar'
import Menu from './Menu'

export default (props: LayoutProps) => {
    return <Layout {...props} sx={{marginTop: '21px'}} appBar={AppBar} menu={Menu}/>
};
